class ContinuousScrollComponent extends HTMLElement {
  constructor() {
    super();
    this.initScrolling();
  }

  initScrolling() {
    const carousel = this.querySelector('.carousel[data-carousel*="carousel-"]');
    if (carousel) {
      this.setupScrolling(carousel);
    }
  }

  setupScrolling(carousel) {
    const speed = parseInt(this.dataset.speed, 10) || 1;
    const scrollAmount = 1;
    const items = Array.from(carousel.children);

    // Clone the items and append them to the carousel
    const clone = items.map(item => item.cloneNode(true));
    carousel.append(...clone);

    let totalWidth = carousel.scrollWidth;

    // Adjust totalWidth if the items are not taking up full space
    if (totalWidth <= carousel.clientWidth) {
      carousel.append(...clone); // Clone again for smoother scroll if needed
      totalWidth = carousel.scrollWidth;
    }

    let lastTimestamp = 0;

    // Function to animate the scrolling
    const animate = (timestamp) => {
      if (!lastTimestamp) lastTimestamp = timestamp;
      const elapsed = timestamp - lastTimestamp;

      // Update scroll position every 16ms (~60fps)
      if (elapsed > 16) {
        carousel.scrollLeft += scrollAmount * speed;

        // Check if we've scrolled through the entire content
        if (carousel.scrollLeft >= totalWidth / 2) {
          carousel.scrollLeft = 0; // Reset scroll position to the start
        }

        lastTimestamp = timestamp;
      }

      // Continue the animation
      requestAnimationFrame(animate);
    };

    // Start the animation
    requestAnimationFrame(animate);
  }
}

// Define the custom element
customElements.define('continuous-scroll-component', ContinuousScrollComponent);
